export type ReportMemoInput = {
  time: string; place: string; direction?: string; company?: string;
  appearance?: Array<{ item: string; match: "같았어요" | "달랐어요" | "모름" }>;
};
export function createReportMemo(input: ReportMemoInput): string {
  const parts = [`${input.time.trim() || "방금"}, ${input.place.trim() || "본 장소를 아직 적지 않았습니다"}에서 닮은 분을 봤습니다.`];
  const observations = (input.appearance ?? []).filter(v => v.match !== "모름").map(v => `${v.item} ${v.match === "같았어요" ? "같았습니다" : "달랐습니다"}`);
  if (observations.length) parts.push(`${observations.join(", ")}.`);
  if (input.direction) parts.push(`${input.direction}쪽으로 이동했습니다.`);
  if (input.company) parts.push(`${input.company}.`);
  parts.push("신원은 확인하지 못했습니다.");
  return parts.join(" ");
}
export function smsHref(text: string, platform: "ios" | "android"): string {
  return `sms:112${platform === "ios" ? "&" : "?"}body=${encodeURIComponent(text)}`;
}
